<template>
  <div>
    <el-row>
      <el-col :span="12">
        <el-button type="default" @click="setDiscount()">设置优惠</el-button>
      </el-col>
    </el-row>
    <div class="table">
      <el-table :data="list" @expand-change="getCustomerMemberListByShopId">
        <el-table-column type="expand">
          <template slot-scope="scope">
            <el-table :data="scope.row.list">
              <el-table-column label="买家抬头" prop="customerName"></el-table-column>
              <!-- <el-table-column label="近三个月订单数" prop="desc"></el-table-column>
              <el-table-column label="成交重量" prop="equity"></el-table-column>
              <el-table-column label="成交金额" prop="number"></el-table-column> -->
              <el-table-column label="操作" width="120px">
                <template slot-scope="org">
                  <el-button type="text" size="small" @click="setLevel(org.row)">
                    设置会员等级
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column label="会员等级名称" prop="type">
          <template slot-scope="scope">
            {{ scope.row.type | memberLevelText }}
          </template>
        </el-table-column>
        <el-table-column label="会员定义" prop="desc"></el-table-column>
        <el-table-column label="会员权益" prop="reductionAmount">
          <template slot-scope="scope">
            <span v-if="scope.row.reductionAmount === 0">不享受优惠</span>
            <span v-else>商品发布单价 - {{ scope.row.reductionAmount / 100 }} 元</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="会员数量" prop="number"></el-table-column> -->
      </el-table>
    </div>
    <el-dialog title="设置会员等级" :visible.sync="levelDialogVisible">
      <el-form :model="levelDialog">
        <el-form-item label="会员等级">
          <el-radio-group v-model="levelDialog.memberLevel">
            <el-radio :label="1">普通用户</el-radio>
            <el-radio :label="2">店铺会员</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="levelDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmSetLevel">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="设置优惠" :visible.sync="discountDialogVisible">
      <el-form :model="discountDialog" label-width="120px">
        <el-form-item label="普通用户:">
          <el-radio label="不享受优惠" value="不享受优惠"></el-radio>
        </el-form-item>
        <el-form-item label="店铺会员:">
          <el-radio-group v-model="discountDialog.discountType">
            <el-radio :label="1">不享受优惠</el-radio>
            <el-radio :label="2">享受优惠</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="商品发布单价:" v-if="discountDialog.discountType === 2">
          <el-input @input="priceInput" v-model="discountDialog.price">
            <template slot="prepend">-</template>
            <template slot="append">元</template>
          </el-input>
          <div style="color:#cd974c">注：按照商品计价单位自动扣减</div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="discountDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmDiscount">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import limit from 'common/utils/limit'
export default {
  name: 'MemberEquityList',
  data() {
    return {
      list: [
        // { name: '普通客户', desc: '有过交易的用户', equity: '成交价：商品发布价', number: '6' },
        // { name: '店铺会员', desc: '手动设置', equity: '成交价：商品会员价', number: '3' }
      ],
      levelDialogVisible: false,
      levelDialog: {
        memberLevel: 1
      },
      discountDialogVisible: false,
      discountDialog: {
        discountType: 1,
        price: ''
      }
    }
  },
  created() {
    this.getList()
  },
  filters: {
    memberLevelText(value) {
      let memberLevel = {
        1: '普通用户',
        2: '店铺会员'
      }
      return memberLevel[value]
    }
  },
  methods: {
    setDiscount() {
      let memberPrice = this.list.find(item => {
        return item.type === 2
      })
      const reductionAmount = memberPrice ? memberPrice.reductionAmount : ''
      this.discountDialog.discountType = !reductionAmount ? 1 : 2
      this.discountDialog.price = reductionAmount ? reductionAmount / 100 : ''
      this.discountDialogVisible = true
    },
    setLevel(item) {
      this.levelDialog.memberLevel = item.memberSign
      this.levelDialog.crmId = item.crmId
      this.levelDialogVisible = true
    },
    async confirmSetLevel() {
      let res = await this.$get('crm.service.member.shopMemberModify', {
        param: {
          crmId: this.levelDialog.crmId,
          memberSignl: this.levelDialog.memberLevel
        }
      })
      if (res && res.success) {
        this.$message.success('会员等级设置成功！')
        this.levelDialogVisible = false
        this.getList()
      } else {
        this.$message.error('操作失败')
      }
    },
    priceInput(value, item) {
      value = limit.amount(value)
      // value = value === '' ? 1 : value
      value = value > 100 ? 100 : value
      // value = value.replace(/[^\d.]/g, '')
      // value = value.replace(/^\./g, '')
      // value = value.replace(/\.{2,}/g, '.')
      // value = value.replace('.', '$#$').replace(/\./g, '')
      // value = value.replace('$#$', '.')
      // value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
      this.discountDialog.price = value
    },
    async getList() {
      let { success, data } = await this.$get('promotion.getMemberPromotionList')
      if (success) {
        this.list = data[0].memberPromotionList || []
        this.list = this.list.map(item => {
          return {
            ...item,
            list: []
          }
        })
      }
    },
    async confirmDiscount() {
      let { success } = await this.$get('promotion.addMemberPromotion', {
        addMemberPromotion: {
          memberPromotionParamList: [
            {
              type: 1,
              reductionAmount: 0
            },
            {
              type: 2,
              reductionAmount:
                this.discountDialog.discountType === 1 ? 0 : this.discountDialog.price * 100
            }
          ]
        }
      })
      if (success) {
        this.discountDialogVisible = false
        this.$message.success('会员权益设置成功')
        this.getList()
      }
    },
    async getCustomerMemberListByShopId(row, expanded) {
      try {
        let res = await this.$get('crm.service.member.getCustomerMemberListByShopId', {
          param: {
            shopIds: [this.$store.state.shop.info.id],
            memberSignl: row.type
          }
        })
        if (res && res.success) {
          row.list = res.data[0].crmMemberResultList || []
        } else {
          this.$message.error('获取失败')
        }
      } catch (error) {
        this.$message.error('获取失败')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.table {
  min-height: 700px;
}
.search-input {
  width: 235px;
}
</style>
